import { createContext, useContext } from "react";

export const DashboardContext = createContext({
  customerId: null,
  readOnly: false,
  customerName: null,
  enterCustomerView: () => {},
});

export const useDashboardCtx = () => useContext(DashboardContext);
